import { setLocale } from "yup";
import "moment/locale/fr";

export var appLanguage = "fr";

setLocale({
    mixed: {
        default: "Valeur non valide",
        required: "Champs requis",
    },
    number: {
        min: "Doit être supérieur à ${min}", // eslint-disable-line no-template-curly-in-string
        max: "Doit être inférieur à ${min}", // eslint-disable-line no-template-curly-in-string
    },
});

/**
 * Now you might be wondering WTH this class is.
 * We used to use https://github.com/lingui/js-lingui/tree/master for translation,
 * and this lib uses the component i18n._("") to marl strings as "translatable",
 * but we stopped really trying to i18ize (??) the app, and the dev stopped updating the lib, which created
 * a shittone of warnings.
 * SO, in an attempt to keep the work already done, and in the hope to one day go back to translating
 * I'm temporarly replacing the Lingui i18n._("") by a mock one.
 *
 * SIMPLY PUT: I'm keeping the i18n._("") tags to make it simpler when we decide to i18ize.
 */
class I18n {
    _(text: string) {
        return text;
    }
}
export const i18n = new I18n();
